export enum ListingType {
    None = 0,
    Stock = 1,
    Branded = 2,
    Pro = 3,
    Elite = 4
}
